import { render, staticRenderFns } from "./PaymentBtn.vue?vue&type=template&id=2659b159&scoped=true&"
import script from "./PaymentBtn.vue?vue&type=script&lang=js&"
export * from "./PaymentBtn.vue?vue&type=script&lang=js&"
import style0 from "./PaymentBtn.vue?vue&type=style&index=0&id=2659b159&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2659b159",
  null
  
)

export default component.exports